import { FingerprintIcon } from '@phosphor-icons/react';
import { T } from 'gt-react';
import {
  isPasskeyPromptDismissed,
  usePasskeyLogin,
} from 'src/api/auth/usePasskeys';
import { Button } from 'src/components/ui/button';
import { Spinner } from 'src/components/ui/spinner';

import { AuthErrorMessage } from './AuthErrorMessage';

interface PasskeyLoginButtonProps {
  disabled: boolean;
  onSuccess: () => Promise<void>;
}

export function PasskeyLoginButton({
  disabled,
  onSuccess,
}: PasskeyLoginButtonProps) {
  const { mutate, isPending, error } = usePasskeyLogin();

  return (
    <>
      <Button
        type="button"
        variant="outline"
        disabled={disabled || isPending}
        onClick={() => mutate(undefined, { onSuccess })}
        className="w-full gap-2"
      >
        {isPending ? (
          <Spinner />
        ) : (
          <>
            <FingerprintIcon className="size-4" aria-hidden="true" />
            <T context="button label to sign in with a passkey on the login page">
              Sign in with a passkey
            </T>
          </>
        )}
      </Button>
      {!isPasskeyPromptDismissed(error) && <AuthErrorMessage error={error} />}
    </>
  );
}
